import { type SocialMediaLinkBrand } from './types.js';
import { getSocialIconViaBrand } from './utils.js';
import { IconSvgProps } from '@contra/icons/icons';

export const SocialMediaIcon = ({
  brand,
  ...svgProps
}: IconSvgProps & {
  readonly brand: SocialMediaLinkBrand;
  readonly size?: '100%' | number;
}) => {
  const Icon = getSocialIconViaBrand(brand);

  return <Icon {...svgProps} />;
};
